import { gql } from './apollo';

export const GET_BLOCKED_EMAILS = gql`
    query (
        $offset: Int = 0
        $limit: Int = 10
        $orderBy: String = "email"
        $orderByDirection: GraphQLDirection = ASC
        $filter: MultiTypeInput = "%"
    ) {
        table(
            name: "blocked"
            filter: [{ left: "email", right: $filter, expression: "iLIKE" }]
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderByDirection: $orderByDirection
        )
    }
`;

export const CREATE_BLOCKED_EMAIL = gql`
    mutation ($email: MultiTypeInput) {
        createRow(table: "blocked", values: [{ property: "email", value: $email }])
    }
`;

export const DELETE_BLOCKED_EMAIL = gql`
    mutation ($id: String!) {
        deleteRow(table: "blocked", id: $id)
    }
`;
